var map = {
	"./adult_premium_filled.svg": 1426,
	"./age_filled.svg": 1244,
	"./annuity_start_age_filled.svg": 1276,
	"./avg_premium_filled.svg": 1249,
	"./currency_filled.svg": 1278,
	"./deductible_filled.svg": 1251,
	"./first_year_premium_filled.svg": 1377,
	"./gender_filled.svg": 1280,
	"./geographical_coverage_filled.svg": 1282,
	"./income_term_filled.svg": 1284,
	"./issue_age_filled.svg": 1286,
	"./multiple_claims_filled.svg": 1288,
	"./objective_filled.svg": 1290,
	"./occupation_filled.svg": 1292,
	"./owner_type_filled.svg": 1294,
	"./payment_term_filled.svg": 1296,
	"./property_age_filled.svg": 1428,
	"./property_gross_area_filled.svg": 1430,
	"./property_type_filled.svg": 1298,
	"./renewal_term_filled.svg": 1300,
	"./risk_preference_filled.svg": 1302,
	"./room_type_filled.svg": 1304,
	"./smoker_status_filled.svg": 1306,
	"./sort_filled.svg": 1232,
	"./sum_assured_filled.svg": 1253,
	"./target_period_filled.svg": 1309,
	"./total_premium_filled.svg": 1311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1941;